<template>
  <transition name="pa-toast-fade">
    <div v-if="message" class="pa-toast" role="status" aria-live="polite">{{ message }}</div>
  </transition>
</template>

<script>
import { POP_AUTHORITY_TOAST_EVENT } from '@/utils/popAuthority'

const VISIBLE_MS = 3200 // design pa-app.jsx showToast

/**
 * The design's confirmation toast (pa.css .pa-toast): a teal pill at the bottom centre of the
 * screen, gone after 3.2 seconds. Mounted once by the POP Authority layout; any component shows a
 * message with `showPopAuthorityToast(this, 'text')` from utils/popAuthority. A new message
 * replaces the current one and restarts the timer. Errors keep using the app's red notifications.
 */
export default {
  name: 'PopAuthorityToast',
  data () {
    return { message: '', timer: null }
  },
  created () {
    this.$root.$on(POP_AUTHORITY_TOAST_EVENT, this.show)
  },
  beforeDestroy () {
    this.$root.$off(POP_AUTHORITY_TOAST_EVENT, this.show)
    clearTimeout(this.timer)
  },
  methods: {
    show (message) {
      clearTimeout(this.timer)
      this.message = String(message || '')
      if (this.message) this.timer = setTimeout(() => { this.message = '' }, VISIBLE_MS)
    },
  },
}
</script>

<style lang="scss" scoped>
/* design pa.css .pa-toast */
.pa-toast {
  position: fixed;
  bottom: 26px;
  left: 50%;
  transform: translateX(-50%);
  background: var(--v-mainColor-base, #014751);
  color: #fff;
  border-radius: 10px;
  padding: 12px 20px;
  font-weight: 700;
  font-size: 0.9rem;
  line-height: 1.45;
  z-index: 70;
  box-shadow: 0 4px 18px rgba(1, 71, 81, 0.14);
  display: flex;
  gap: 14px;
  align-items: center;
  max-width: calc(100vw - 32px);
}

.pa-toast-fade-enter-active,
.pa-toast-fade-leave-active {
  transition: opacity 0.15s;
}

.pa-toast-fade-enter,
.pa-toast-fade-leave-to {
  opacity: 0;
}
</style>
